<template>
  <vs-card>
    <div class="text-center py-10">
      <h3 class="text-6xl text-black text-opacity-75" v-text="value"/>
      <h5 class="text-black text-opacity-75 capitalize" v-text="text"/>
    </div>
  </vs-card>
</template>

<script>
export default {
  props: ["value", "text"]
}
</script>

<style>

</style>